import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/RadioButton/RadioButtonAnatomy.mdx";
import Usage from "../../Docs/Components/RadioButton/RadioButtonUsage.mdx";

import Examples from "../../Docs/Components/RadioButton/RadioButtonExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Radio button"
            description="Radio buttons represent a list of mutually exclusive options."
            apiSources={["azure-devops-ui/Components/RadioButton/RadioButton.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;